import { SectionTabItem } from 'components/Layout/MobileShell/SectionTabs';

// Abas do Mailer no mobile — as três seções renderizadas pelo MailerLayout
// (Relatórios, E-mail em massa, Templates).
const MAILER_SECTION_TABS: SectionTabItem[] = [
  { title: 'Relatórios', path: '/admin/mailer/reports' },
  { title: 'E-mail em massa', path: '/admin/mailer/mass-emails' },
  { title: 'Templates', path: '/admin/mailer/templates' },
];

export default MAILER_SECTION_TABS;
